import React from "react";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { Grid, IconButton, Typography } from "@mui/material";

export const Thermostat = ({ temperature, onChange }: ThermostatProps) => {
  const handleTempIncrease = () => {
    onChange(temperature + 1);
  };

  const handleTempDecrease = () => {
    onChange(temperature - 1);
  };

  return (
    <Grid item container alignItems="center" justifyContent="center">
      <IconButton onClick={handleTempDecrease}>
        <RemoveCircleOutlineIcon fontSize="large" />
      </IconButton>
      <Grid
        item
        container
        direction="column"
        sx={{ position: "relative", flex: 0 }}
      >
        <img src="/static/img/termos-bg.svg" alt="" />
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            flex: 1,
            height: "100%",
          }}
        >
          <Typography
            variant="h1"
            color="primary"
            component="span"
            sx={{ mb: 0 }}
          >
            {`${temperature}º`}
          </Typography>
        </Grid>
      </Grid>
      <IconButton onClick={handleTempIncrease}>
        <AddCircleOutlineIcon fontSize="large" />
      </IconButton>
    </Grid>
  );
};

export type ThermostatProps = {
  temperature: number;
  onChange: (newTemp: number) => void;
};
